<template>
  <v-text-field
    :rules="rules"
    v-bind="[fieldProps, $attrs]"
    autocomplete="name"
    label="Nome"
    name="name"
  ></v-text-field>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Digite seu nome.")],
  }),
  mixins: [mixin],
};
</script>
